import type { FC } from 'react'

import styled from 'styled-components'

import Box from 'app/components/design-system-components/Box'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

interface IMessagePreview {
  message?: string
  property?: {
    optionMeta?: { displayText?: string }
  }
}

const StyledBox = styled(Box)`
  white-space: pre-line;
`

export const MessagePreview: FC<IMessagePreview> = ({
  message = '',
  property,
}) => {
  const { optionMeta = {} } = property || {}
  const { displayText = '' } = optionMeta
  return (
    <Box
      backgroundColor={theme.colors.paleBlue}
      overflowY="scroll"
      height="360px"
      p={theme.space[6] + 'px'}
      my={theme.space[6] + 'px'}
    >
      <Box textAlign="center">
        <h3>{`Deposit Received: ${displayText || `[property address]`}`}</h3>
      </Box>
      <Box>
        <br />
        Hi [addressee],
        <br />
        <Box>
          The deposit has been received for [property address]. Please see the
          confirmation of the tenancy details.
        </Box>
        <br />
        <strong>Lease Details</strong>
        <Box>
          <ul>
            <li>
              <strong>Tenants:</strong> [Tenant Name]
            </li>
            <br />
            <li>
              <strong>Term:</strong> [Term]
            </li>
            <br />
            <li>
              <strong>Start:</strong> [Start Date]
            </li>
            <br />
            <li>
              <strong>End:</strong> [End Date]
            </li>
            <br />
            <li>
              <strong>Rent:</strong> [Rent Amount] / week
            </li>
            <br />
            <li>
              <strong>Rent Frequency:</strong> [Rent Frequency]
            </li>
            <br />
            <li>
              <strong>Pets:</strong> [Pets Allowed]
            </li>
            <br />
            <li>
              <strong>Water:</strong> [Water]
            </li>
            <br />
          </ul>
        </Box>
        {message && (
          <>
            <b>Message:</b>
            <StyledBox>{message}</StyledBox>
          </>
        )}
        <br />
        For more information contact:
        <br />
        [agent name]
        <br />
        [agency phone]
        <br />
        [agenct email]
        <br />
        <br />
        Regards,
        <br />
        <strong>[Agency Name]</strong>
      </Box>
    </Box>
  )
}
